// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Mixins **/
/** Vars (common) **/
/** app colors **/
/** Vars (MuiAlert) **/
/** main classes **/
.nibCardImage_old-container__0Kxwa {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.nibCardImage_old-container__0Kxwa.nibCardImage_wrap__BkOlF {
  flex-wrap: wrap;
}
.nibCardImage_old-container__0Kxwa .nibCardImage_box__aZYHc.nibCardImage_col__CnNq4 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
}
.nibCardImage_old-container__0Kxwa .nibCardImage_box__aZYHc.nibCardImage_col__CnNq4 > div {
  width: 100%;
}
.nibCardImage_old-container__0Kxwa .nibCardImage_box__aZYHc.nibCardImage_row__FLTXD {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.nibCardImage_old-container__0Kxwa form {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
}
.nibCardImage_old-container__0Kxwa form > .nibCardImage_box__aZYHc.nibCardImage_col__CnNq4 {
  flex-basis: 33.33%;
}
@media screen and (min-width: 2560px) {
  .nibCardImage_old-container__0Kxwa form > .nibCardImage_box__aZYHc.nibCardImage_col__CnNq4 {
    flex-basis: 0%;
    margin-right: 2em;
  }
}

@media screen and (max-width: 580px) {
  .nibCardImage_old-container__0Kxwa, .nibCardImage_col__CnNq4, form {
    padding: 5px;
  }
}
@media screen and (max-width: 450px) {
  .nibCardImage_old-container__0Kxwa, .nibCardImage_col__CnNq4, form {
    padding: 0px;
  }
}
.nibCardImage_text-overflow-hidden__SYcK- {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nibCardImage_icon__328tg {
  color: var(--accent-color);
}

.nibCardImage_richtext-output-wrap__b3mcs .nibCardImage_se-video-container__u-faI figure {
  padding-bottom: 0 !important;
}

.nibCardImage_wrap__BkOlF {
  width: 100%;
  padding: 10px 20px;
}
.nibCardImage_wrap__BkOlF h4 {
  color: var(--accent-color);
  font-size: 80%;
  font-weight: 300;
  padding-bottom: 5px;
}
.nibCardImage_wrap__BkOlF .nibCardImage_box__aZYHc {
  border: 2px solid var(--accent-color);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  padding: 5px;
}
.nibCardImage_wrap__BkOlF .nibCardImage_box__aZYHc p {
  font-size: 90%;
  padding: 5px 10px;
  align-self: flex-start;
}
.nibCardImage_wrap__BkOlF .nibCardImage_box__aZYHc img {
  max-width: 100%;
}
.nibCardImage_wrap__BkOlF .nibCardImage_box__aZYHc .nibCardImage_over__87tE4 {
  opacity: 0;
  transition: opacity 0.5s ease;
  background: rgba(0, 0, 0, 0.35);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.nibCardImage_wrap__BkOlF .nibCardImage_box__aZYHc .nibCardImage_over__87tE4 p {
  align-self: unset;
  font-size: 110%;
}
.nibCardImage_wrap__BkOlF .nibCardImage_box__aZYHc:hover .nibCardImage_over__87tE4 {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/sass/_settings.sass","webpack://./src/components/common/NibCard/NibCardImage/nibCardImage.module.sass"],"names":[],"mappings":"AAAA,aAAA;AAeA,oBAAA;AAgBA,iBAAA;AA0BA,sBAAA;AAGA,mBAAA;AACA;EA3DE,aAAA;EACA,mBA4DM;EA3DN,8BA2DW;EA1DX,uBA0D0B;EAC1B,kBAAA;EACA,WAAA;ACrDF;ADsDE;EACE,eAAA;ACpDJ;ADsDI;EAnEF,aAAA;EACA,sBAmEU;EAlEV,2BAkEkB;EAjElB,uBAiE8B;EAC1B,eAAA;ACjDN;ADkDM;EACE,WAAA;AChDR;ADiDI;EAxEF,aAAA;EACA,mBAwEU;EAvEV,2BAuEe;EAtEf,uBAsE2B;EACvB,WAAA;AC5CN;AD6CE;EACE,aAjDK;EA3BP,aAAA;EACA,mBA4EQ;EA3ER,2BA2Ea;EA1Eb,uBA0EyB;EACvB,kBAAA;EACA,eAAA;EACA,WAAA;ACxCJ;ADyCI;EACE,kBAAA;ACvCN;ADwCM;EAFF;IAGI,cAAA;IACA,iBAAA;ECrCN;AACF;;ADsCA;EAEE;IACE,YAFO;EClCT;AACF;ADoCA;EAEE;IACE,YAFO;ECjCT;AACF;ADoCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AClCF;;ADoCA;EACE,0BAtFO;ACqDT;;ADqCI;EACE,4BAAA;AClCN;;AAzEA;EACI,WAAA;EACA,kBAAA;AA4EJ;AA3EI;EACI,0BDYC;ECXD,cAAA;EACA,gBAAA;EACA,mBAAA;AA6ER;AA5EI;EACI,qCAAA;EACA,kBAAA;EDVN,aAAA;EACA,sBCUY;EDTZ,2BCSoB;EDRpB,mBCQgC;EAC1B,kBAAA;EACA,YAAA;AAiFR;AAhFQ;EACI,cAAA;EACA,iBAAA;EACA,sBAAA;AAkFZ;AAjFQ;EACI,eAAA;AAmFZ;AAlFQ;EACI,UAAA;EACA,6BAAA;EACA,+BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;ED7BV,aAAA;EACA,mBC6BgB;ED5BhB,uBC4BqB;ED3BrB,mBC2B6B;AAuF/B;AAtFY;EACI,iBAAA;EACA,eAAA;AAwFhB;AAtFY;EACI,UAAA;AAwFhB","sourcesContent":["/** Mixins **/\n=flex($der, $justy, $align)\n  display: flex\n  flex-direction: $der\n  justify-content: $justy\n  align-items: $align\n\n=shadow()\n  box-shadow: -5px 5px 10px 0px rgba(#000, .35)\n\n=staticHeight($height)\n  min-height: $height\n  max-height: $height\n  height: $height\n\n/** Vars (common) **/\n$main: #2F2F2F\n$main_background: #191818\n$accent: var(--accent-color)\n$accent_text: var(--accent-text-color)\n$accent_r: var(--accent-color-r)\n$accent_g: var(--accent-color-g)\n$accent_g10: var(--accent-color-g10)\n$accent_b: var(--accent-color-b)\n$text: #cecece\n$error: #f44336\n$success: rgb(102, 187, 106)\n$container_background_color: #1B1B1B\n$container_item_background_color: #212121\n$gutter: 20px\n\n/** app colors **/\n$soft_teal: #84aaaf\n$fiery_red: #ff3131\n$muted_red: #e85a4f\n$app_red: #B83336\n$soft_creamy: #f5e8dd\n$light_gray: #535353\n$golden_yellow: #ffc107\n$orange: #ffa725\n$app_orange: #DB890E\n$warm_orange: #e3a869\n$faded_pink: #d69fa2\n$purple: #8868a3\n$app_purple: #7E51A3\n$light_blue: #79a8d1\n$app_green: #16962F\n$retro_green: #4a7c59\n$deep_blue: #406ca8\n\n$main_block_top_padding: 130px\n$main_block_top_padding_s: 70px\n$header_height: 120px\n$sidebar_width: 320px\n\n$table_row_height: 55px\n\n/** Vars (MuiAlert) **/\n$MuiAlert_main_color: rgb(166, 213, 250)\n\n/** main classes **/\n.old-container\n  //padding: $gutter\n  +flex(row, space-between, flex-start)\n  position: relative\n  width: 100%\n  &.wrap\n    flex-wrap: wrap\n  .box\n    &.col\n      +flex(column, flex-start, flex-start)\n      padding: 0 calc($gutter/2)\n      > div\n        width: 100%\n    &.row\n      +flex(row, flex-start, flex-start)\n      width: 100%\n  form\n    padding: $gutter\n    +flex(row, flex-start, flex-start)\n    position: relative\n    flex-wrap: wrap\n    width: 100%\n    > .box.col\n      flex-basis: 33.33%\n      @media screen and ( min-width: 2560px )\n        flex-basis: 0%\n        margin-right: 2em\n\n@media screen and ( max-width: 580px )\n  $gutter: 5px\n  .old-container, .col, form\n    padding: $gutter\n@media screen and ( max-width: 450px )\n  $gutter: 0px\n  .old-container, .col, form\n    padding: $gutter\n\n.text-overflow-hidden\n  overflow: hidden\n  text-overflow: ellipsis\n  white-space: nowrap\n\n.icon\n  color: $accent\n\n.richtext-output-wrap\n  .se-video-container\n    figure\n      padding-bottom: 0 !important\n","@import '../../../../sass/settings'\n\n.wrap\n    width: 100%\n    padding: calc($gutter/2) $gutter\n    h4\n        color: $accent\n        font-size: 80%\n        font-weight: 300\n        padding-bottom: 5px\n    .box\n        border: 2px solid $accent\n        border-radius: 4px\n        +flex(column, flex-start, center)\n        position: relative\n        padding: 5px\n        p\n            font-size: 90%\n            padding: 5px calc($gutter/2)\n            align-self: flex-start\n        img\n            max-width: 100%\n        .over\n            opacity: 0\n            transition: opacity .5s ease\n            background: rgba(#000, .35)\n            position: absolute\n            top: 0\n            left: 0\n            width: 100%\n            height: 100%\n            cursor: pointer\n            +flex(row, center, center)\n            p\n                align-self: unset\n                font-size: 110%\n        &:hover\n            .over\n                opacity: 1\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"old-container": `nibCardImage_old-container__0Kxwa`,
	"wrap": `nibCardImage_wrap__BkOlF`,
	"box": `nibCardImage_box__aZYHc`,
	"col": `nibCardImage_col__CnNq4`,
	"row": `nibCardImage_row__FLTXD`,
	"text-overflow-hidden": `nibCardImage_text-overflow-hidden__SYcK-`,
	"icon": `nibCardImage_icon__328tg`,
	"richtext-output-wrap": `nibCardImage_richtext-output-wrap__b3mcs`,
	"se-video-container": `nibCardImage_se-video-container__u-faI`,
	"over": `nibCardImage_over__87tE4`
};
export default ___CSS_LOADER_EXPORT___;
